module.exports = __webpack_public_path__ + "static/media/3.bef8658e.jpg";